<template>
  <div>
    <input type="hidden" class="uk-input" name="double" v-model="model" />
    <div class="icon-list" :class="{ mini: label == false }">
      <template v-for="icon in icons">
        <div class="icon-in-list" :class="{ active: model == icon }">
          <vk-icon :icon="icon" @click="model = icon" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        "home",
        "sign-in",
        "sign-out",
        "user",
        "users",
        "lock",
        "unlock",
        "settings",
        "cog",
        "nut",
        "comment",
        "commenting",
        "comments",
        "hashtag",
        "tag",
        "cart",
        "credit-card",
        "mail",
        "receiver",
        "search",
        "location",
        "bookmark",
        "code",
        "paint-bucket",
        "camera",
        "bell",
        "bolt",
        "star",
        "heart",
        "happy",
        "lifesaver",
        "rss",
        "social",
        "git-branch",
        "git-fork",
        "world",
        "calendar",
        "clock",
        "history",
        "future",
        "pencil",
        "trash",
        "move",
        "link",
        "question",
        "info",
        "warning",
        "image",
        "thumbnails",
        "table",
        "list",
        "menu",
        "grid",
        "more",
        "more-vertical",
        "plus",
        "plus-circle",
        "minus",
        "minus-circle",
        "close",
        "check",
        "ban",
        "refresh",
        "play",
        "play-circle",
        "tv",
        "desktop",
        "laptop",
        "tablet",
        "phone",
        "tablet-landscape",
        "phone-landscape",
        "file",
        "copy",
        "file-edit",
        "folder",
        "album",
        "push",
        "pull",
        "server",
        "database",
        "cloud-upload",
        "cloud-download",
        "download",
        "upload",
        "reply",
        "forward",
        "expand",
        "shrink",
        "arrow-up",
        "arrow-down",
        "arrow-left",
        "arrow-right",
        "chevron-up",
        "chevron-down",
        "chevron-left",
        "chevron-right",
        "triangle-up",
        "triangle-down",
        "triangle-left",
        "triangle-right",
        "bold",
        "italic",
        "strikethrough",
        "video-camera",
        "quote-right",
        "500px",
        "behance",
        "dribbble",
        "facebook",
        "flickr",
        "foursquare",
        "github",
        "github-alt",
        "gitter",
        "google",
        "google-plus",
        "instagram",
        "joomla",
        "linkedin",
        "pagekit",
        "pinterest",
        "soundcloud",
        "tripadvisor",
        "tumblr",
        "twitter",
        "uikit",
        "vimeo",
        "whatsapp",
        "wordpress",
        "xing",
        "yelp",
        "youtube"
      ],
      model: null
    };
  },
  props: ["input", "form", "value", "label"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style>
.icon-in-list {
  display: inline-block;
  padding: 5px;
}
.icon-list {
  border: 1px solid #e5e5e5;
  color: #ccc;
  padding: 10px;
}
.active {
  color: #222;
  background: #eee;
}
.mini {
  width: 400px;
}
</style>
